/**
 * Course Configuration Constants
 * Shared constants for course IDs and settings
 */

// Course IDs
export const COURSE_IDS = {
  ITWS1100: 'itws1100',
  RP001: 'rp001',
  ITWS4500: 'itws4500'
};

// Total lessons in RP001 course
export const RP001_TOTAL_LESSONS = 14;

export default COURSE_IDS;
